import { morphSection } from '@theme/section-renderer';
import { CartUpdateEvent } from '@theme/events';

window.scpProps = window.scpProps || { '__preTaxPrice': 0 };

// SHIP +
const insuranceProductID = '47924487160058';

// -------------------- Cart state helpers --------------------

async function getCart() {
    const res = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store',
    });
    return res.json();
}

async function findInsurance() {
    const cart = await getCart();
    const item = cart.items.find((i) => Number(i.id) === Number(insuranceProductID));
    return { item, cart };
}

// -------------------- Shimmer helpers --------------------

function shimmer(on = true) {
    document
        .querySelectorAll(
            'text-component[ref="cartTotal"], .cart__total text-component'
        )
        .forEach((t) => (on ? t?.shimmer?.() : t?.reset?.()));
}

// -------------------- Add / Remove --------------------

async function addInsurance() {
    shimmer(true);
    await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
            id: insuranceProductID,
            quantity: 1,
            properties: window.scpProps,
        }),
    });
    shimmer(false);
    const cart = await getCart();
    document.dispatchEvent(
        new CartUpdateEvent(cart, 'cart-insurance', { source: 'cart-insurance' })
    );
}

async function removeInsurance(item) {
    if (!item?.key) return;
    shimmer(true);
    await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: item.key, quantity: 0 }),
    });
    shimmer(false);
    const cart = await getCart();
    document.dispatchEvent(
        new CartUpdateEvent(cart, 'cart-insurance', { source: 'cart-insurance' })
    );
}

// -------------------- Initial auto-add --------------------

async function enforceInsurance() {
    const { item, cart } = await findInsurance();
    const denied = sessionStorage.getItem('shipPlusDenied') === 'true';
    const haveOtherItems = cart.items.some(
        (i) => Number(i.id) !== Number(insuranceProductID)
    );

    // remove if only insurance left
    if (item && !haveOtherItems) {
        await removeInsurance(item);
        updateToggle(false);
        return;
    }

    // add if missing and not denied
    if (!item && haveOtherItems && !denied) {
        await addInsurance();
        updateToggle(true);
        return;
    }

    updateToggle(!!item);
}

// -------------------- Toggle handling --------------------

function updateToggle(state) {
    const toggle = document.querySelector('#insurance-toggle');
    if (toggle) toggle.checked = !!state;
}

async function handleInsurance(e) {
    const toggle = e.target;
    toggle.disabled = true;
    const { item } = await findInsurance();

    if (toggle.checked && !item) {
        await addInsurance();
        sessionStorage.setItem('shipPlusDenied', 'false');
    } else if (!toggle.checked && item) {
        await removeInsurance(item);
        sessionStorage.setItem('shipPlusDenied', 'true');
    }

    const refreshed = await findInsurance();
    toggle.checked = !!refreshed.item;
    toggle.disabled = false;
}

// -------------------- Event Listeners --------------------

document.body.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'insurance-toggle') {
        handleInsurance(e);
    }
});

document.addEventListener('cart:update', (e) => {
    if (e?.detail?.data?.source === 'cart-insurance') return;
    enforceInsurance();
});

document.addEventListener('DOMContentLoaded', enforceInsurance);